import { useQuery } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
export interface IncentiveCard {
  id: number;
  title: string;
  description: string;
  image: string;
  linkUrl: string;
  linkText: string;
}
export interface Incentives {
  id: number;
  quote: string;
  cards: IncentiveCard[];
}
export const fetchIncentives = async (): Promise<Incentives> => {
  const {
    data
  } = await http.get(API_ENDPOINTS.INCENTIVES);
  return data;
};
export const fetchRecentIncentives = async (): Promise<Incentives> => {
  const {
    data
  } = await http.get(API_ENDPOINTS.INCENTIVES);
  return {
    ...data,
    cards: data.cards.slice(0, 5)
  };
};
export const useIncentivesQuery = () => {
  return useQuery<Incentives, Error>('incentives/incentives', fetchIncentives, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5
  });
};
export const useRecentIncentivesQuery = () => {
  return useQuery<Incentives, Error>(['incentives/incentives', 'recent'], fetchRecentIncentives, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    staleTime: 15 * 60 * 1000,
    cacheTime: 15 * 60 * 1000
  });
};